import { connect } from "react-redux";
import SetTargetDate from "./setTargetDate";
import { bindActionCreators } from "redux";
import {
  getTargetDataSequence,
  postTargetData,
  postVerifyData,
} from "services/redux/installation/TargetDate/action";

const mapStateToProps = (state) => ({
  targetDate: state.targetDataSequenceReducer.targetData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getTargetDataSequence,
      postTargetData,
      postVerifyData,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SetTargetDate);
